var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h2',[_vm._v("Log in")]),_c('a',{attrs:{"href":_vm.authUrl}},[_vm._v("Log in with Twitch")]),(_vm.error)?_c('div',{staticClass:"error",domProps:{"textContent":_vm._s(_vm.error)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }